import { IKRA_LOGO } from "@/data/content";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 lg:pt-40 pb-20 lg:pb-28 overflow-hidden"
    >
      {/* Ambient gold glow — subtle */}
      <div
        aria-hidden
        className="pointer-events-none absolute right-[-200px] top-[-100px] w-[600px] h-[600px] rounded-full blur-3xl -z-0"
        style={{ background: "radial-gradient(circle, rgba(255,199,44,0.08), transparent 60%)" }}
      />

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-[var(--ikra-gold)]">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--ikra-gold-bright)] ikra-pulse" />
            Działamy od 2026
          </div>

          <h1
            data-testid="hero-headline"
            className="mt-8 font-display text-5xl sm:text-6xl lg:text-[96px] leading-[1.02] tracking-tight text-[var(--ikra-ink)] uppercase"
          >
            Masz Ikrę?
            <br />
            <span className="text-[var(--ikra-gold)]">Dołącz do nas.</span>
          </h1>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a
              href="#aplikuj"
              data-testid="hero-cta-apply"
              className="btn-primary inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-sm font-semibold"
            >
              Dołącz do zespołu
              <span aria-hidden>→</span>
            </a>
            <a
              href="#kim-jestesmy"
              data-testid="hero-cta-learn"
              className="btn-ghost inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-sm font-medium"
            >
              Poznaj nas
            </a>
          </div>
        </div>

        {/* Kim jesteśmy */}
        <div id="kim-jestesmy" className="mt-24 lg:mt-32 max-w-4xl">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight text-[var(--ikra-ink)]">
            Kim jesteśmy
          </h2>
          <span className="mt-4 inline-block h-0.5 w-16 bg-[var(--ikra-gold)]" />
          <div className="mt-8 space-y-6 text-lg lg:text-xl text-[var(--ikra-muted)] leading-relaxed">
            <p>
              Prowadzimy kampanie sprzedażowe dla organizacji pozarządowych,
              firm i osób prywatnych. Pomagamy naszym klientom zdobywać nowych
              klientów i osiągać lepsze wyniki.
            </p>
            <p>
              Stawiamy na skuteczną pracę, dobre relacje z ludźmi i ciągły
              rozwój. Naszym celem jest robić swoją pracę dobrze i osiągać
              realne rezultaty.
            </p>
          </div>
        </div>

        {/* Trust strip */}
        <div className="mt-20 lg:mt-24 grid grid-cols-1 sm:grid-cols-2 gap-y-10 gap-x-8 border-y border-[var(--ikra-line)] py-10 max-w-2xl">
          <Stat value="100%" label="Pasji" />
          <Stat value="24/7" label="Dobre nastawienie" />
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-display text-3xl lg:text-4xl text-[var(--ikra-gold)] tracking-tight">
        {value}
      </div>
      <div className="mt-1.5 text-xs uppercase tracking-[0.18em] text-[var(--ikra-muted)]">
        {label}
      </div>
    </div>
  );
}
